import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import React, { createContext, useMemo } from 'react';
import { compile, match } from 'path-to-regexp';
import useRoutes from "../hooks/useRoutes";
export var RoutesContext = /*#__PURE__*/createContext(null);
export function routesFileToContext(routesFile) {
  if (!routesFile) return null;
  var retVal = {};
  Object.keys(routesFile).forEach(function (key) {
    retVal[key] = {
      to: routesFile[key],
      match: match(key),
      toPath: compile(routesFile[key])
    };
  });
  return retVal;
}
var RoutesWrapper = function RoutesWrapper(_ref) {
  var children = _ref.children;
  var routesFile = useRoutes();
  var routes = useMemo(function () {
    return routesFileToContext(routesFile);
  }, [routesFile]);
  return /*#__PURE__*/React.createElement(RoutesContext.Provider, {
    value: routes
  }, children);
};
export default RoutesWrapper;